import $ from 'jquery';
import {url,errorCheck,sucErrorCheck} from '../common/url.js';

const Service={
    //用户登录信息
    loadUserInfo:function(){
      return new Promise((resolve, reject) => {
            $.ajax({
                url: url + "/jhApi.do?method=loadUserInfo",
                type: 'post',
                dataType: 'JSON',
                cache: false,
                success: (result) => {
                     resolve(result);
                },
                error: (xhr, status, err) => {
                },
            });
      })
    },
    //入会
    vipIn:function(){
        return new Promise((resolve,reject) =>{
            $.ajax({
                url: url + "/jhApi.do?method=levelUp",
                type: 'post',
                dataType: 'JSON',
                cache: false,
                success: (result) => {
                    if(result.code == 0 ){
                        resolve(result) ;
                    }else{
                        sucErrorCheck(result);
                    }
                },
                error: (xhr, status, err) => {
                     errorCheck(xhr, status, err);
                },
            })
        })
    },
    //首页配置
    listConfig:function(kindId){
        return new Promise((resolve,reject) =>{
            $.ajax({
                url: url + "/jhApi.do?method=listConfig",
                type: 'post',
                dataType: 'JSON',
                cache: false,
                data:{
                    prodModule:'JHHY',
                    kindId:kindId
                },
                success: (result) => {
                    if(result.code == 0 ){
                        resolve(result) ;
                    }else{
                        sucErrorCheck(result);
                    }
                },
                error: (xhr, status, err) => {
                    errorCheck(xhr, status, err);
                },
            })
        })
    },
    //资讯栏目获取
    listInfo:function(startIndex,endIndex,typeCode,tagName,searchText){
        return new Promise((resolve,reject) =>{
            $.ajax({
                url: url + "/jhApi.do?method=listInfo",
                type: 'post',
                dataType: 'JSON',
                cache: false,
                async:false,
                data:{
                    startIndex:startIndex,
                    endIndex:endIndex,
                    typeCode:typeCode,
                    tag:tagName,
                    queryContent:searchText
                },
                success: (result) => {
                    if(result.code == 0 ){
                        resolve(result) ;
                    }else{
                        sucErrorCheck(result);
                    }
                },
                error: (xhr, status, err) => {
                    errorCheck(xhr, status, err);
                },
            })
        })
    },
    //资讯详情获取
    infoDetail:function(infoId){
        return new Promise((resolve,reject) =>{
            $.ajax({
                url: url + "/jhApi.do?method=infoDetail",
                type: 'post',
                dataType: 'JSON',
                async: false,
                data:{
                    infoId:infoId
                },
                success: (result) => {
                    if(result.code == 0 ){
                        resolve(result) ;
                    }else{
                        sucErrorCheck(result);
                    }
                },
                error: (xhr, status, err) => {
                    errorCheck(xhr, status, err);
                },
            })
        })
    },
 }
export default Service


// WEBPACK FOOTER //
// ./src/server/server.js